import React from "react";
import { Button, HStack, Text } from "native-base";
import { Loc } from "../../App/Loc";

const RenderFilters = ({ categories, selectedFilter, handleFilters }) => {
  return (
    <>
      {categories.map((category, index) => {
        return (
          <HStack key={index}>
            <Button
              borderRadius={"19px"}
              height={"36px"}
              paddingLeft={"24px"}
              paddingRight={"24px"}
              bgColor={selectedFilter === category ? "#2FA3BE" : ""}
              onPress={() => {
                handleFilters(category);
              }}
            >
              <Text
                color={
                  selectedFilter === category ? "white" : "rgba(0,0,0,0.6)"
                }
                fontWeight={400}
                fontSize={"16px"}
              >
                {category === "Current"
                  ? Loc.currentLang.menu.current
                  : category === "Past"
                    ? Loc.currentLang.menu.past
                    : category === "Canceled"
                      ? Loc.currentLang.menu.canceled
                      : category === "Meeting"
                        ? Loc.currentLang.menu.meeting
                        : category === "Social"
                          ? Loc.currentLang.menu.social
                          : category === "Game"
                            ? Loc.currentLang.menu.gamesTxt
                            : category}
              </Text>
            </Button>
          </HStack>
        );
      })}
    </>
  );
};

export default RenderFilters;
